import * as palette from './colors'
import Color from 'color'

export const yellow = {
  'name': 'yellow-theme',
  'primary-200': palette.yellow200,
  'primary-600': palette.yellow600,
  'primary-400': palette.yellow400,
  'primary-100': palette.yellow100,
  'accent-1': palette.red400,
  'accent-2': palette.red200,
  'accent-3': palette.blue400,
  'accent-4': palette.blue200,
  'text-dark': palette.grey800,
  'text-light': palette.white000
}

export const blue = {
  'name': 'blue-theme',
  'primary-200': palette.blue200,
  'primary-600': palette.blue600,
  'primary-400': palette.blue400,
  'primary-100': palette.blue100,
  'accent-1': palette.yellow600,
  'accent-2': palette.yellow400,
  'accent-3': palette.green200,
  'accent-4': palette.purple200,
  'text-dark': palette.grey800,
  'text-light': palette.white000
}

export const green = {
  'name': 'green-theme',
  'primary-200': palette.green200,
  'primary-600': palette.green600,
  'primary-400': palette.green400,
  'primary-100': palette.green100,
  'accent-1': palette.yellow600,
  'accent-2': palette.red200,
  'accent-3': palette.grey400,
  'accent-4': palette.purple200,
  'text-dark': palette.grey800,
  'text-light': palette.white000
}

export const grey = {
  'name': 'grey-theme',
  'primary-200': palette.grey400,
  'primary-600': palette.grey700,
  'primary-400': palette.grey600,
  'primary-100': palette.grey200,
  'accent-1': palette.grey500,
  'accent-2': palette.grey300,
  'accent-3': palette.grey200,
  'accent-4': palette.grey800,
  'text-dark': palette.grey800,
  'text-light': palette.white000
}

export const custom = (customColor) => ({
  'name': 'custom-theme',
  'primary-200': customColor,
  'primary-600': Color(customColor).darken(0.5).hex(),
  'primary-400': customColor,
  'primary-100': Color(customColor).lighten(0.5).hex(),
  'accent-1': palette.grey600,
  'accent-2': palette.grey500,
  'accent-3': palette.grey400,
  'accent-4': palette.grey200,
  'text-dark': palette.grey800,
  'text-light': palette.white000
})

// used for tables/charts for fetching colors
export const getThemeColor = (index, theme) => {
  switch (index) {
    case 0:
      return theme['primary-200']
    case 1:
      return theme['accent-1']
    case 2:
      return theme['accent-3']
    case 3:
      return theme['accent-4']
    case 4:
      return theme['primary-600']
  }
  return theme['primary-200']
}
